import React, { FC, useEffect, useState } from 'react'
import { Modal } from '@components/Modals/Modal'
import { QuizNotification } from './QuizNotification/QuizNotification'
import { QuizSurvey } from './QuizSurvey/QuizSurvey'
import { QuizEnd } from './QuizEnd/QuizEnd'

interface Props {
    closeHandler: () => void
}

export const Quiz: FC<Props> = ({ closeHandler }) => {
    const [screen, setScreen] = useState('notification')

    useEffect(() => {
        // Блокируем скролл при открытии модального окна
        document.body.style.overflow = 'hidden'
        return () => {
            // Восстанавливаем скролл после закрытия модального окна
            document.body.style.overflow = ''
        }
    }, [])
    return (
        <Modal
            isOpen
            onClose={closeHandler}
            shouldCloseOnOverlayClick={true}>
            {screen === 'notification' ? <QuizNotification onClick={() => setScreen('survey')} /> : screen === 'survey' ? <QuizSurvey handleEndSurvey={() => setScreen('end')} /> : <QuizEnd closeHandler={closeHandler} />}
        </Modal>
    )
}
